import {useEffect,useState} from 'react'

// Matches the approved single-pane phone/closed Fold layout only.
export default function useNarrowScreen(){
 const [narrow,setNarrow]=useState(()=>matchMedia('(max-width:599px)').matches)
 useEffect(()=>{const query=matchMedia('(max-width:599px)'),update=()=>setNarrow(query.matches);query.addEventListener('change',update);return()=>query.removeEventListener('change',update)},[])
 return narrow
}
